export default __webpack_public_path__ + "static/media/nexpert.bf474eb1.png";